export const DEFAULT_SLOT_GRANULARITY_MINUTES = 30;
const HOURLY_SLOT_GRANULARITY_MINUTES = 60;
const HALF_HOUR_SESSION_DURATIONS = [30, 60, 90, 120];
const HOURLY_SESSION_DURATIONS = [60, 120];

function formatSlotTime(minutesSinceMidnight: number): string {
  const hour = String(Math.floor(minutesSinceMidnight / 60)).padStart(2, '0');
  const minute = String(minutesSinceMidnight % 60).padStart(2, '0');
  return `${hour}:${minute}`;
}

export function venueSlotGranularityMinutes(slotGranularityMinutes?: number | null): number {
  return slotGranularityMinutes === HOURLY_SLOT_GRANULARITY_MINUTES
    ? HOURLY_SLOT_GRANULARITY_MINUTES
    : DEFAULT_SLOT_GRANULARITY_MINUTES;
}

export function sessionDurationOptions(slotGranularityMinutes?: number | null): number[] {
  return venueSlotGranularityMinutes(slotGranularityMinutes) === HOURLY_SLOT_GRANULARITY_MINUTES
    ? HOURLY_SESSION_DURATIONS
    : HALF_HOUR_SESSION_DURATIONS;
}

export function slotTimes(slotGranularityMinutes?: number | null): string[] {
  const granularity = venueSlotGranularityMinutes(slotGranularityMinutes);
  const slotsPerDay = (24 * 60) / granularity;
  return Array.from({ length: slotsPerDay }, (_, index) => formatSlotTime(index * granularity));
}
